import { render, staticRenderFns } from "./TestingRightSide.vue?vue&type=template&id=3355ed95&scoped=true&"
import script from "./TestingRightSide.vue?vue&type=script&lang=js&"
export * from "./TestingRightSide.vue?vue&type=script&lang=js&"
import style0 from "./TestingRightSide.vue?vue&type=style&index=0&id=3355ed95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355ed95",
  null
  
)

export default component.exports